import axios from 'axios';
import config from '../config';

class InvitationService {
  // Register with invitation code
  registerWithInvitation(username, email, password, fundPassword, invitationCode) {
    return axios.post(config.api.auth + '/register', {
      username,
      email,
      password,
      fundPassword,
      invitationCode
    });
  }

  // Verify invitation code
  verifyInvitation(invitationCode) {
    return axios.post(config.api.auth + '/verify-invitation', {
      invitationCode
    });
  }
}

export default new InvitationService();